<!--
 * @FileDescription: 学生简历页面 
   @author： 祝通
 -->
<template>
	<div>
		<el-collapse v-model="activeNames">
			<el-collapse-item name="1">
				<template slot="title">
					<i class="el-icon-user" style="font-size: 25px;margin-left:25px;"></i>
					<div style="color:#17c3e5;font-size:18px;font-weight:bold;padding-left:25px;display: block;width:170px;">个人信息</div>
					<div v-if="ifShowIntegrity">
						<el-tag style="margin-left:20px;" type="warning" effect="dark" v-if="proinfo.wechatId == null">待完善</el-tag>
						<el-button v-else size="small" style="margin-left:20px;font-weight: bold;" type="success" icon="el-icon-check"
						 circle></el-button>
					</div>
				</template>
				<el-divider><span style="font-size:18px;font-weight:bold;">个人信息</span> </el-divider>
				<div style="margin-left:17%;width:60%;">
					<el-form  label-width="200px">

						<el-form-item label="名字">
							<el-input readonly v-model="proinfo.firstName"></el-input>
						</el-form-item>
						<el-form-item label="姓氏">
							<el-input readonly v-model="proinfo.lastName"></el-input>
						</el-form-item>
						<el-form-item label="昵称">
							<el-input readonly v-model="proinfo.englishName"></el-input>
						</el-form-item>
						<el-form-item label="生日">
							<el-date-picker readonly type="date" v-model="proinfo.birthday" value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
						<el-form-item label="性别">
							<el-input v-if="proinfo.gender == 1" readonly value="Male"></el-input>
							<el-input v-if="proinfo.gender == 2" readonly value="Female"></el-input>
						</el-form-item>
						<el-form-item label="邮箱">
							<el-input readonly v-model="proinfo.email"></el-input>
						</el-form-item>
						<el-form-item label="微信号" prop="wechatId">
							<el-input readonly v-model="proinfo.wechatId"></el-input>
						</el-form-item>
						<el-form-item label="LinkedIn">
							<el-input readonly v-model="proinfo.linkedIn"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<el-divider><span style="font-size:18px;font-weight:bold;">附件</span> </el-divider>
				<div style="margin-left:17%;width:60%;">
					<el-form label-width="200px" style="margin-top:10px;">
						<el-form-item label="简历">
							<!-- <el-input v-if="proinfo.resume != null" :value="resumeList.toString()" readonly style="width:78%;"></el-input> -->
							<el-input v-if="proinfo.resume == null" placeholder="无附件信息" readonly style="width:78%;"></el-input>
							<!-- <el-button v-if="proinfo.resume != null" @click="checkDownload(0)"  style="margin-left:10px;" icon="el-icon-search" circle></el-button> -->
							<ImageSelect :imageList="proinfo.resume" />
						</el-form-item>
						<el-form-item label="求职信">
							<el-input v-if="proinfo.coverLetter == null" placeholder="无附件信息" readonly style="width:78%;"></el-input>
							<ImageSelect :imageList="[proinfo.coverLetter]" />
						</el-form-item>
						<el-form-item label="LinkedIn资料">
							<el-input v-if="proinfo.linkedinProfileSummary == null" placeholder="无附件信息" readonly style="width:78%;"></el-input>
							<ImageSelect :imageList="[proinfo.linkedinProfileSummary]" />
						</el-form-item>
						<el-form-item label="网络电子邮件">
							<el-input v-if="proinfo.networkingEmail == null" placeholder="无附件信息" readonly style="width:78%;"></el-input>
							<ImageSelect :imageList="[proinfo.networkingEmail]" />
						</el-form-item>
						<el-form-item label="跟进电子邮件">
							<el-input v-if="proinfo.followUpEmail == null" placeholder="无附件信息" readonly style="width:78%;"></el-input>
							<ImageSelect :imageList="[proinfo.followUpEmail]" />
						</el-form-item>
						<el-form-item label="感谢信">
							<el-input v-if="proinfo.thankYouLetter == null" placeholder="无附件信息" readonly style="width:78%;"></el-input>
							<ImageSelect :imageList="[proinfo.thankYouLetter]" />
						</el-form-item>
					</el-form>
				</div>
			</el-collapse-item>

			<el-collapse-item name="2">
				<template slot="title">
					<i class="el-icon-collection" style="font-size: 25px;margin-left:25px;"></i>
					<div style="color:#17c3e5;font-size:18px;font-weight:bold;padding-left:25px;display: block;width:170px;">教育经历</div>
					<div v-if="ifShowIntegrity">
						<el-tag style="margin-left:20px;" type="warning" effect="dark" v-if="lastEducation.id == 0">待完善</el-tag>
						<el-button v-if="lastEducation.id != 0" size="small" style="margin-left:20px;font-weight: bold;" type="success"
						 icon="el-icon-check" circle></el-button>
					</div>
				</template>
				<el-divider><span style="font-size:18px;font-weight:bold;">最新教育经历</span> </el-divider>
				<div style="margin-left:17%;width:60%;">
					<el-form label-width="210px">
						<el-form-item label="学校" prop="universityId">
							<el-input v-model="lastEducation.universityId" readonly></el-input>
						</el-form-item>
						<el-form-item label="学位" prop="degreeId">
							<el-input v-model="lastEducation.degreeId" readonly></el-input>
						</el-form-item>
						<el-form-item label="研究领域" prop="fieldOfStudyId">
							<span >
								{{lastEducation.fieldOfStudyId}}
							</span>
						</el-form-item>
						<el-form-item label="专业" prop="major">
							<el-input v-model="lastEducation.major" readonly></el-input>
							<el-checkbox readonly v-model="lastEducation.ifStem == 1">STEM</el-checkbox>
						</el-form-item>
						<el-form-item label="第二专业(非必选)">
							<el-input readonly v-model="lastEducation.secondMajor"></el-input>
						</el-form-item>
						<el-form-item label="Minor (if any)">
							<el-input readonly v-model="lastEducation.minor"></el-input>
						</el-form-item>
						<el-form-item label="入学时间" prop="timePeriodStart">
							<el-date-picker readonly value-format="yyyy-MM-dd" style="width: 100%;" v-model="lastEducation.timePeriodStart" type="month"
							 >
							</el-date-picker>
						</el-form-item>
						<el-form-item label="毕业时间(/预计)" prop="timePeriodEnd">
							<el-date-picker readonly value-format="yyyy-MM-dd" style="width: 100%;" v-model="lastEducation.timePeriodEnd" type="month"
							 >
							</el-date-picker>
						</el-form-item>
						<el-form-item label="备注">
							<el-input readonly v-model="lastEducation.remark"></el-input>
						</el-form-item>
						<el-form-item label="GPA/大学成绩">
							<el-input readonly v-model="lastEducation.universityGradesId" style="width: 30%;"></el-input>
							<el-input readonly v-model="lastEducation.universityGradesDetail" style="width: 67%;margin-left:3%;"></el-input>
						</el-form-item>
					</el-form>
				</div>

				<el-divider><span style="font-size:18px;font-weight:bold;">以往教育经历</span> </el-divider>
				<div style="margin-left:17%;width:60%;" v-for="(item,index) in pastEducation">
					<el-form  label-width="210px">
						<el-form-item label="学校" prop="universityId">
							<el-input readonly v-model="item.universityId"></el-input>
						</el-form-item>
						<el-form-item label="学位" prop="degreeId">
							<el-input readonly v-model="item.degreeId"></el-input>
						</el-form-item>
						<el-form-item label="研究领域" prop="fieldOfStudyId">
							<span >
								{{item.fieldOfStudyId}}
							</span>
						</el-form-item>
						<el-form-item label="专业" prop="major">
							<el-input readonly v-model="item.major"></el-input>
							<el-checkbox readonly v-model="item.ifStem == 1" >STEM</el-checkbox>
						</el-form-item>
						<el-form-item label="第二专业(非必选)">
							<el-input readonly v-model="item.secondMajor"></el-input>
						</el-form-item>
						<el-form-item label="辅修专业">
							<el-input readonly v-model="item.minor"></el-input>
						</el-form-item>
						<el-form-item label="入学时间" prop="timePeriodStart">
							<el-date-picker readonly value-format="yyyy-MM-dd" style="width: 100%;" v-model="item.timePeriodStart" type="month"
							 >
							</el-date-picker>
						</el-form-item>
						<el-form-item label="毕业时间(/预计)" prop="timePeriodEnd">
							<el-date-picker readonly value-format="yyyy-MM-dd" style="width: 100%;" v-model="item.timePeriodEnd" type="month"
							 >
							</el-date-picker>
						</el-form-item>
						<el-form-item label="备注">
							<el-input readonly v-model="item.remark"></el-input>
						</el-form-item>
						<el-form-item label="GPA/大学成绩">
							<el-input readonly v-model="item.universityGradesId" style="width: 30%;"></el-input>
							<el-input v-model="item.universityGradesDetail" style="width: 67%;margin-left:3%;"></el-input>
						</el-form-item>
					</el-form>

				</div>
			</el-collapse-item>
			<el-collapse-item name="3">
				<template slot="title">
					<i class="el-icon-document" style="font-size: 25px;margin-left:25px;"></i>
					<div style="color:#17c3e5;font-size:18px;font-weight:bold;padding-left:25px;display: block;width:170px;">工作经验</div>
					<div v-if="ifShowIntegrity">
						<el-tag style="margin-left:20px;" type="warning" effect="dark" v-if="userWorkInfo.id == 0">待完善</el-tag>
						<el-button v-if="userWorkInfo.id != 0" size="small" style="margin-left:20px;font-weight: bold;" type="success"
						 icon="el-icon-check" circle></el-button>
					</div>
				</template>
				<el-divider><span style="font-size:18px;font-weight:bold;">实习经验</span>
				</el-divider>
				<div style="margin-left:17%;width:60%;">
					<el-form  label-position="top"  label-width="100%">
						<el-form-item label="实习总次数(含中国)" prop="internshipCount">
							<el-input readonly v-model="userWorkInfo.internshipCount"></el-input>
						</el-form-item>
						<el-form-item label="在你学习的国家实习的次数" prop="countryInternshipCount">
							<el-input readonly v-model="userWorkInfo.countryInternshipCount"></el-input>
						</el-form-item>
						<el-form-item label="你的实习经历是否与你目前的目标求职行业相关?" prop="internshipType">
							<el-input v-if="userWorkInfo.internshipType == 1" readonly value="Yes"></el-input>
							<el-input v-if="userWorkInfo.internshipType == 2" readonly value="No"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div v-if="userWorkInfo.internshipCount != 0">
					<div v-for="(item,index) in internshipExperience">
						<div v-if="index == 0" style="text-align: center;color:#ffbe18;margin-bottom:15px;">最近实习经历</div>
						<div v-if="index == 1" style="text-align: center;color:#ffbe18;margin-bottom:15px;">以往实习经历</div>
						<div style="margin-left:17%;width:60%;">
							<el-form label-width="80px" style="margin-top:10px;">
								<el-form-item label="公司地区">
									<el-input readonly v-model="item.location[0]" style="width: 25%;"></el-input>
									<el-input readonly v-model="item.location[1]" style="width: 25%;"></el-input>
									<el-input readonly v-model="item.location[2]" style="width: 25%;"></el-input>
									<el-input readonly v-model="item.location[2]" style="width: 25%;"></el-input>
								</el-form-item>
								<el-form-item label="公司领域">
									<el-input readonly :value="item.industryName+' - '+item.typeName + ' - '+item.workName"></el-input>
								</el-form-item>
								<el-form-item label="公司名称">
									<el-input readonly v-model="item.companyName"></el-input>
								</el-form-item>
								<el-form-item label="公司地址">
									<el-input readonly v-model="item.position"></el-input>
								</el-form-item>
								<el-form-item label="入职时间">
									<el-date-picker readonly value-format="yyyy-MM-dd" style="width: 100%;" v-model="item.startTime" type="month"
									>
									</el-date-picker>
								</el-form-item>
								<el-form-item label="离职时间">
									<el-date-picker readonly :disabled="item.endState == 1" value-format="yyyy-MM-dd"  type="month" style="width: 100%;" v-model="item.endTime"
									 >
									</el-date-picker>
									<el-checkbox readonly v-model="item.endState == 1" >Until now</el-checkbox>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div v-if="internshipExperience.length == 1" style="text-align: center;color:#ffbe18;margin-bottom:15px;">以往实习经历</div>
				</div>

				<el-divider><span style="font-size:18px;font-weight:bold;">全职工作经历</span>
				</el-divider>
				<div style="margin-left:17%;width:60%;">
					<el-form  label-position="top" label-width="100%">
						<el-form-item label="你在你学习的国家有全职工作经验吗?" prop="workCount">
							<el-input readonly v-model="userWorkInfo.workCount"></el-input>
						</el-form-item>
						<el-form-item label="它是否与你目前的目标求职行业相关?" prop="whetherRelevant">
							<el-input v-if="userWorkInfo.whetherRelevant == 1" readonly value="Yes"></el-input>
							<el-input v-if="userWorkInfo.whetherRelevant == 2" readonly value="No"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div v-if="userWorkInfo.workCount != 0">
					<div v-for="(item,index) in fullTimeExperience">
						<div v-if="index == 0" style="text-align: center;color:#ffbe18;margin-bottom:15px;">Most Recent Full-time</div>
						<div style="margin-left:17%;width:60%;">
							<el-form label-width="80px" style="margin-top:10px;">
								<el-form-item label="公司地区">
									<el-input readonly v-model="item.location[0]" style="width: 25%;"></el-input>
									<el-input readonly v-model="item.location[1]" style="width: 25%;"></el-input>
									<el-input readonly v-model="item.location[2]" style="width: 25%;"></el-input>
									<el-input readonly v-model="item.location[3]" style="width: 25%;"></el-input>
								</el-form-item>
								<el-form-item label="公司领域">
									<el-input readonly :value="item.industryName+' - '+item.typeName + ' - '+item.workName"></el-input>
								</el-form-item>
								<el-form-item label="公司名称">
									<el-input readonly v-model="item.companyName"></el-input>
								</el-form-item>
								<el-form-item label="公司地址">
									<el-input readonly v-model="item.position"></el-input>
								</el-form-item>
								<el-form-item label="入职时间">
									<el-date-picker readonly value-format="yyyy-MM-dd" style="width: 100%;" v-model="item.startTime" type="month"
									>
									</el-date-picker>
								</el-form-item>
								<el-form-item label="离职时间">
									<el-date-picker readonly :disabled="item.endState == 1" value-format="yyyy-MM"  type="month" style="width: 100%;" v-model="item.endTime">
									</el-date-picker>
									<el-checkbox readonly v-model="item.endState == 1" >Until now</el-checkbox>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</el-collapse-item>
			<el-collapse-item name="4">
				<template slot="title">
					<i class="el-icon-document-checked" style="font-size: 25px;margin-left:25px;"></i>
					<div style="color:#17c3e5;font-size:18px;font-weight:bold;padding-left:25px;display: block;width:170px;">求职意向</div>
					<div v-if="ifShowIntegrity">
						<el-tag style="margin-left:20px;" type="warning" effect="dark" v-if="userJobSearchDetail.id == 0">待完善</el-tag>
						<el-button v-if="userJobSearchDetail.id != 0" size="small" style="margin-left:20px;font-weight: bold;" type="success"
						 icon="el-icon-check" circle></el-button>
					</div>
				</template>
				<el-divider><span style="font-size:18px;font-weight:bold;">Select & Enter</span> </el-divider>
				<div style="margin-left:17%;width:60%;">
					<el-form  label-width="240px">
						<el-form-item label="求职状态" prop="workStatus">
							<el-input readonly v-model="userJobSearchDetail.workStatus"></el-input>
							<el-input readonly style="margin-top:15px;" v-if="userJobSearchDetail != null && userJobSearchDetail.workStatus == 'Other'"
							 v-model="userJobSearchDetail.workStatusOther"></el-input>
						</el-form-item>
						<el-form-item label="获得求职状态的面试次数">
							<el-input readonly type="number" v-model="userJobSearchDetail.interviewsCount"></el-input>
						</el-form-item>
						<el-form-item label="目标工作性质" style="position: relative;">
							<el-tag type="info" v-for="item in jobWorkNatures" :key="item">{{item}}</el-tag>
						</el-form-item>
						<el-form-item label="目标地区(1st)" prop="targetCountryId">
							<el-input readonly v-model="userJobSearchDetail.targetCountryId[0]" style="width: 25%;"></el-input>
							<el-input readonly v-model="userJobSearchDetail.targetCountryId[1]" style="width: 25%;"></el-input>
							<el-input readonly v-model="userJobSearchDetail.targetCountryId[2]" style="width: 25%;"></el-input>
							<el-input readonly v-model="userJobSearchDetail.targetCountryId[3]" style="width: 25%;"></el-input>
						</el-form-item>
						<el-form-item label="目标地区(2nd)">
							<el-input readonly v-model="userJobSearchDetail.targetCountry2Id[0]" style="width: 25%;"></el-input>
							<el-input readonly v-model="userJobSearchDetail.targetCountry2Id[1]" style="width: 25%;"></el-input>
							<el-input readonly v-model="userJobSearchDetail.targetCountry2Id[2]" style="width: 25%;"></el-input>
							<el-input readonly v-model="userJobSearchDetail.targetCountry2Id[3]" style="width: 25%;"></el-input>
						</el-form-item>
						<el-form-item label="目标工作" style="position: relative;">
							<div v-for="(item,index) in jobWorkTargets" style="margin-bottom:10px;">
								<el-input readonly :value="item.industryName" style="width:30%;"></el-input>
								<el-input readonly :value="item.typeName" style="width:30%;margin-left:5%;"></el-input>
								<el-input readonly :value="item.workName" style="width:30%;margin-left:5%;"></el-input>
							</div>
						</el-form-item>
						<el-form-item label="工作问题" style="position: relative;">
							<el-tag type="info" v-for="item in jobConcerns" :key="item">{{item}}</el-tag>
						</el-form-item>
						<el-form-item label="工作签证是问题吗？" prop="ifWorkVisa">
							<el-input v-if="userJobSearchDetail.ifWorkVisa == 1" readonly value="Yes"></el-input>
							<el-input v-if="userJobSearchDetail.ifWorkVisa == 2" readonly value="No"></el-input>
							<el-input v-if="userJobSearchDetail.ifWorkVisa == 3" readonly value="It depends"></el-input>
						</el-form-item>
						<el-form-item label="OPT" v-if="userJobSearchDetail.ifWorkVisa == 1">
							<el-date-picker readonly value-format="yyyy-MM-dd" style="width: 45%;" v-model="userJobSearchDetail.optStartTime"
							 >
							</el-date-picker>
							<div style="display:inline-block;width: 10%;text-align: center;">至</div>
							<el-date-picker readonly value-format="yyyy-MM-dd" style="width: 45%;" v-model="userJobSearchDetail.optEndTime"
							 >
							</el-date-picker>
						</el-form-item>
						<el-form-item label="原因" v-if="userJobSearchDetail.ifWorkVisa == 2">
							<el-input readonly v-model="userJobSearchDetail.reason"></el-input>
						</el-form-item>
						<el-form-item label="面试英语流利性" prop="englishFluencyInInterviews">
							<el-input v-if="userJobSearchDetail.englishFluencyInInterviews == 1" readonly value="Very Fluent"></el-input>
							<el-input v-if="userJobSearchDetail.englishFluencyInInterviews == 2" readonly value="Moderately"></el-input>
							<el-input v-if="userJobSearchDetail.englishFluencyInInterviews == 3" readonly value="Not Fluent"></el-input>
						</el-form-item>
					</el-form>
				</div>

				<el-divider><span style="font-size:18px;font-weight:bold;">Details</span> </el-divider>
				<div style="margin-left:17%;width:60%;">

					<el-form label-position="top" label-width="100%">
						<el-form-item label="你的目标公司/部门/职位是什么?" prop="targetingPositions">
							<el-input autosize readonly type="textarea" v-model="userJobSearchDetail.targetingPositions" ></el-input>
						</el-form-item>
						<el-form-item label="关于辅导课程，你有什么特别的要求或担忧想要与导师分享吗?"
						 prop="courseRequirements">
							<el-input autosize readonly type="textarea" v-model="userJobSearchDetail.courseRequirements"></el-input>
						</el-form-item>
						<el-form-item label="您希望OneCareer提供什么样的求职材料?">
							<el-input autosize readonly type="textarea" v-model="userJobSearchDetail.jobHuntingMaterials"></el-input>
						</el-form-item>
						<el-form-item label="您还有什么想让我们知道的吗?">
							<el-input autosize readonly type="textarea" v-model="userJobSearchDetail.remark"></el-input>
						</el-form-item>
					</el-form>
				</div>
			</el-collapse-item>

		</el-collapse>
		
	</div>
</template>
<script>
	import utils from '@/utils';
	import ImageSelect from "@/components/ImageSelect";
	export default {
		components: {
			ImageSelect
		},
		name: 'home',
		props:['email'],
		data() {
			return {
				ifShowIntegrity:false,
				//是否提交，如果正在请求后端则改为false
				//用户基本信息
				proinfo:{},
				//用户教育信息
				lastEducation:{},
				pastEducation:[],
				//可用大学，学位，研究领域，大学成绩，公司信息——用于下拉选择
				educationSelect:{},
				//被删除的教育信息id
				delEducationIds:[],
				//添加大学信息对话框
				universityDialog:false,
				//添加大学信息下标，表示新增后要返回到哪组数据
				universityIndex:-1,
				//添加大学信息名称
				universityName:"",
				//用户工作经验信息
				userWorkInfo:{},
				fullTimeExperience:[],
				internshipExperience:[],
				//被删除的工作信息id
				delExperienceIds:[],
				//工作次数，用于下拉选择
				workCountList:[0,1,2,3,4,5,6,7,8,9,10],
				//添加公司信息对话框
				companyDialog:false,
				//添加公司信息下标，表示新增后要返回到哪组数据
				companyIndex:-1,
				//添加公司信息名称
				companyName:"",
				//添加公司类型，实习还是工作经验，表示新增后要返回到哪组数据
				companyType:0,
				//用户求职信息
				userJobSearchDetail:{
					targetCountryId:["","",""],
					targetCountry2Id:["","",""],
				},
				//用户选择的工作性质
				jobWorkNatures:[],
				//用户选择的目标工作
				jobWorkTargets:[],
				//用户选择的工作问题
				jobConcerns:[],
				//折叠面板
				activeNames:"1",
				
				//用于resume展示的list
				resumeList:[],
				
				ifShowFieldOther:false,
				
			}
		},
		watch:{
			
		},
		methods: {
			//下载附件
			checkDownload(index){
				if(index == 0){
					if(this.proinfo.resume != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							for(let i=0;i<this.proinfo.resume.length;i++){
								window.open(this.proinfo.resume[i].url);
							}
						})
					}
				}
				if(index == 1){
					if(this.proinfo.coverLetter != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.coverLetter.url);
						})
					}
				}
				if(index == 2){
					if(this.proinfo.linkedinProfileSummary != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.linkedinProfileSummary.url);
						})
					}
				}
				if(index == 3){
					if(this.proinfo.networkingEmail != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.networkingEmail.url);
						})
					}
				}
				if(index == 4){
					if(this.proinfo.followUpEmail != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.followUpEmail.url);
						})
					}
				}
				if(index == 5){
					if(this.proinfo.thankYouLetter != null){
						this.$confirm('下载后可以查看附件，确定下载吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'success'
						}).then(() => {
							window.open(this.proinfo.thankYouLetter.url);
						})
					}
				}
			},
			initStudent(email){
        //查询用户个人信息
        utils.requestGet("SP查询用户个人信息","userProfile/queryUserProfile",{
          email:email
        }).then((data) => {
          //处理基础信息的上传文件部分
          if(data.userProfile.resume != null){
            data.userProfile.resume = JSON.parse(data.userProfile.resume);
            for(let i=0;i<data.userProfile.resume.length;i++){
              this.resumeList.push(data.userProfile.resume[i].name);
            }
          }else{
            data.userProfile.resume = [];

          }
          if(data.userProfile.coverLetter != null){
            data.userProfile.coverLetter = JSON.parse(data.userProfile.coverLetter);
          }
          if(data.userProfile.linkedinProfileSummary != null){
            data.userProfile.linkedinProfileSummary = JSON.parse(data.userProfile.linkedinProfileSummary);
          }
          if(data.userProfile.networkingEmail != null){
            data.userProfile.networkingEmail = JSON.parse(data.userProfile.networkingEmail);
          }
          if(data.userProfile.followUpEmail != null){
            data.userProfile.followUpEmail = JSON.parse(data.userProfile.followUpEmail);
          }
          if(data.userProfile.thankYouLetter != null){
            data.userProfile.thankYouLetter = JSON.parse(data.userProfile.thankYouLetter);
          }
          this.proinfo = data.userProfile;

          //处理最后教育信息部分
          if(data.lastEducation == null){
            data.lastEducation = {id:0,b2cUserId:0,ifStem:0};
          }
          this.lastEducation = data.lastEducation;

          this.pastEducation = data.pastEducation;

          //处理工作信息部分
          if(data.userWorkInfo == null){
			  this.userWorkInfo={id:0}
          }else{
            for(let i=0;i<data.fullTimeExperience.length;i++){
				
				let locationA = ['','','',''];

				if(typeof(data.fullTimeExperience[i].location)!='undefined'&&data.fullTimeExperience[i].location!=''){
					let  locationArray = data.fullTimeExperience[i].location.toString().split("|");					
					locationA[0] = typeof(locationArray[0])=="undefined"?'':locationArray[0];
					locationA[1] = typeof(locationArray[1])=="undefined"?'':locationArray[1];
					locationA[2] = typeof(locationArray[2])=="undefined"?'':locationArray[2];
					locationA[3] = typeof(locationArray[3])=="undefined"?'':locationArray[3];
				}
              	data.fullTimeExperience[i].location = locationA;
            }
            for(let i=0;i<data.internshipExperience.length;i++){
				let locationA = ['','','',''];

				if(typeof(data.internshipExperience[i].location)!='undefined'&&data.internshipExperience[i].location!=''){
					let  locationArray = data.internshipExperience[i].location.split("|");					
					locationA[0] = typeof(locationArray[0])=="undefined"?'':locationArray[0];
					locationA[1] = typeof(locationArray[1])=="undefined"?'':locationArray[1];
					locationA[2] = typeof(locationArray[2])=="undefined"?'':locationArray[2];
					locationA[3] = typeof(locationArray[3])=="undefined"?'':locationArray[3];
				}
              	data.internshipExperience[i].location = locationA;
            }
			 this.userWorkInfo = data.userWorkInfo;
          }
          //处理求职意向部分
          if(data.userJobSearchDetail == null){
            data.userJobSearchDetail = {id:0,
              b2cUserId:0,targetCountryId:["","","",""],targetCountry2Id:["","","",""]};
          }else{
            if(data.userJobSearchDetail.targetCountryId != null)
			{
				let locationA = ['','','',''];

				if(typeof(data.userJobSearchDetail.targetCountryId)!='undefined'&&data.userJobSearchDetail.targetCountryId!=''){
					let  locationArray = data.userJobSearchDetail.targetCountryId.split("|");					
					locationA[0] = typeof(locationArray[0])=="undefined"?'':locationArray[0];
					locationA[1] = typeof(locationArray[1])=="undefined"?'':locationArray[1];
					locationA[2] = typeof(locationArray[2])=="undefined"?'':locationArray[2];
					locationA[3] = typeof(locationArray[3])=="undefined"?'':locationArray[3];
				}
              	data.userJobSearchDetail.targetCountryId = locationA;
			}
              
            if(data.userJobSearchDetail.targetCountry2Id != null)
			{
				let locationA = ['','','',''];

				if(typeof(data.userJobSearchDetail.targetCountry2Id)!='undefined'&&data.userJobSearchDetail.targetCountry2Id!=''){
					let  locationArray = data.userJobSearchDetail.targetCountry2Id.split("|");					
					locationA[0] = typeof(locationArray[0])=="undefined"?'':locationArray[0];
					locationA[1] = typeof(locationArray[1])=="undefined"?'':locationArray[1];
					locationA[2] = typeof(locationArray[2])=="undefined"?'':locationArray[2];
					locationA[3] = typeof(locationArray[3])=="undefined"?'':locationArray[3];
				}
              	data.userJobSearchDetail.targetCountry2Id = locationA;
			}
          }
         
          this.fullTimeExperience = data.fullTimeExperience;
          this.internshipExperience = data.internshipExperience;
          this.userJobSearchDetail = data.userJobSearchDetail;
          this.jobWorkNatures = data.jobWorkNatures;
		  
          this.jobWorkTargets = data.jobWorkTargets;
          this.jobConcerns = data.jobConcerns;
          this.ifShowIntegrity = true;
        })
      }
		},
		mounted() {
		}
	}
</script>
<style type="text/css">
</style>
